import { lazy, Suspense } from "react";
import type { ReactCodeMirrorProps } from "@uiw/react-codemirror";

const DynamicCodeMirror = lazy(() => import("./DynamicCodeMirror"));

export const CodeMirror = (props: ReactCodeMirrorProps) => (
  <Suspense>
    <DynamicCodeMirror {...props} />
  </Suspense>
);
